import { SelectionFooter } from "@/components/selection-footer/selection-footer";
import { AnimatePresence, motion } from "framer-motion";
import { DataListFooterProps, ItemWithIdentifier } from "../types";

export function DataListFooter<TData extends ItemWithIdentifier = ItemWithIdentifier>({
  footerComponent,
  isSelectionEnabled,
  selectedCount,
  customSelectionActions,
  selection,
  totalItems,
  onClearSelection,
}: DataListFooterProps<TData>) {
  const showSelection = isSelectionEnabled && selectedCount > 0;

  if (!isSelectionEnabled && !footerComponent) return null;

  const effectiveTotalItems = totalItems ?? 0;

  return (
    <div className="mt-4 flex flex-col gap-4">
      <AnimatePresence>
        {showSelection && (
          <motion.div
            key="selection-footer"
            initial={{ y: 16, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 16, opacity: 0 }}
            transition={{ duration: 0.2, ease: "easeOut" }}
            className="bg-muted/30 flex w-full shrink-0 items-center justify-between px-4 py-3 lg:px-6"
          >
            <SelectionFooter
              selection={selection}
              totalCount={effectiveTotalItems}
              additionalButtons={customSelectionActions?.map((action) => ({
                label: action.label,
                icon: action.icon ? () => action.icon : undefined,
                action: () => action.action(selection.map((id) => ({ uuid: id }) as unknown as ItemWithIdentifier)),
              }))}
              onClearSelection={() => onClearSelection?.()}
            />
          </motion.div>
        )}
      </AnimatePresence>

      {footerComponent && <div className="shrink-0 px-4 lg:px-6">{footerComponent}</div>}
    </div>
  );
}
